// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","content":"Footer_content__1dXVD","link":"Footer_link__MsGIJ","copyright":"Footer_copyright__QJwUC","coffee":"Footer_coffee__sPhww"};